import { EventTicketedCard } from '@components/EntryCard';
import { createBlock } from '@lib/features/blocks/blocks';
import { Entry } from '@lib/features/entries';
import { useAppLink } from '@lib/store';
import { useEffect } from 'react';
import EventCards from './EventCards';
import { useEvents } from './useEvents';

const EventTicketedCardsBlock = createBlock<'blocks_eventTicketedCards_BlockType'>(
  ({ heading, content, eventMultiple: maybeEvents }) => {
    const { trigger, items } = useEvents();
    const indexLink = useAppLink('ticketIndex');

    useEffect(() => {
      if (maybeEvents?.length) return;
      trigger({ isEverydayEvent: false, limit: 4 });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger]);

    return (
      <EventCards
        {...{
          Component: EventTicketedCard,
          heading,
          content,
          items: maybeEvents?.length ? (maybeEvents as Entry<'event'>[]) : items,
          indexLink,
        }}
      />
    );
  }
);

export default EventTicketedCardsBlock;
